import React, { useEffect } from 'react';

function Video({ siwtchVideo }) {
  // 플레이리스트 식별 ID
  // 기존의 식별 아이디
  // let PLAY_LIST_ID = 'PLQR8kAT8yvNdduJjrxeN-g2OAWFFX74tF';
  let PLAY_LIST_ID = 'PLxqru9paLvsERCudhPe_U2MbDveinB7hP';
  // 플레이리스트 목록을 어떤 형식으로 받을 것인지... 해당 값에 따라 json으로 넘어오는 정보가 틀림
  let PART = 'snippet';
  // json으로 받을 플레이리스트 아이템의 최대 개수
  let MAX_RESULT = 10;
  // 플레이리스트 목록 조회를 위한 api키
  let KEY = 'AIzaSyCHwV34dh53X0HnzG3zs4tZGZ8RvXq3KVk';
  // 목록 요청을 위한 rest api url
  let youtubeUrl =
    'https://www.googleapis.com/youtube/v3/playlistItems?playlistId=' +
    PLAY_LIST_ID +
    '&part=' +
    PART +
    '&maxResults=' +
    MAX_RESULT +
    '&key=' +
    KEY;

  let VIDEO_ID = '{videoId}';
  let videoUrl = 'https://www.youtube.com/embed/' + VIDEO_ID;
  // 복사해서 뿌릴 li
  let cloneUl;
  // 동영상 개수
  let videoNum;
  // 첫번째 동영상 번호
  let start = 0;
  // 현재 동영상 번호
  let index = 0;
  // 가져온 동영상 목록
  let jsonDatas;

  // 유튜브 영상 목록 요청
  function requestVideo(url) {
    let request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        // Success
        let jsonData = JSON.parse(this.response);
        let ul = document.querySelector('#video-ul');
        jsonDatas = jsonData;
        videoNum = jsonData.items.length - 1;
        ul.innerHTML = '';
        for (let i = 0; i < jsonData.items.length; i++) {
          ul.insertAdjacentHTML('beforeend', cloneUl);
        }
        addVideo();
      } else {
        function youtubeError(xhr, status, error) {
          console.log('유튜브 요청 에러: ' + error);
        }
      }
    };
    request.send();
  }

  // 동영상 이전버튼 눌렀을때 이벤트 처리
  const videoSlidePrevClick = e => {
    e.preventDefault();
    // 동영상 정지를위해 제거
    removeAddVideo();
    index = index - 1;
    // 현재 동영상이 첫번째 동영상일때 이전버튼 눌렀을때 마지막동영상으로 이동처리
    if (index < start) {
      index = videoNum;
    }
    // 동영상 생성
    addVideo();
    setSlide();
  };

  // 동영상 다음버튼 눌렀을때 이벤트 처리
  const videoSlideNextClick = function (e) {
    e.preventDefault();
    // 동영상 정지를위해 제거
    removeAddVideo();
    index = index + 1;

    // 현재 동영상이 마지막 동영상인데 다음 버튼 눌렀을때 첫번째 동영상으로 이동처리
    if (index > videoNum) {
      index = start;
    }
    // 동영상 생성
    addVideo();
    setSlide();
  };

  const removeAddVideo = function () {
    let getIframe = document.querySelectorAll('.video-popup .iframe');
    let getTitle = document.querySelectorAll('.video-popup .title');
    // 동영상 src 제거해서 동영상 삭제하기
    getIframe[index].removeAttribute('src');
    // 동영상 src생성해서 재생전으로 동영상 올리기
    getTitle[index].textContent = jsonDatas.items[index].snippet.title;
  };

  const addVideo = function () {
    let getIframe = document.querySelectorAll('.video-popup .iframe');
    let getTitle = document.querySelectorAll('.video-popup .title');
    // 동영상 생성
    getIframe[index].setAttribute(
      'src',
      videoUrl.replace(VIDEO_ID, jsonDatas.items[index].snippet.resourceId.videoId)
    );
    getTitle[index].textContent = jsonDatas.items[index].snippet.title;
  };

  // 이전, 다음 동영상 버튼 눌렀을때 클래스명 변경해주기
  const setSlide = function () {
    document.querySelector('.video-popup .video-popup-main ul').setAttribute('class', '');
    document.querySelector('.video-popup .video-popup-main ul').classList.add('index' + index);
  };

  // 팝업 닫기
  const videoPopupClose = function (e) {
    e.preventDefault();
    siwtchVideo();
    // window.history.back();
    // // 팝업 닫을때 다시 처음 동영상으로 돌아가기
    // index = start;
    // setSlide();
    // // 팝업 닫을때 동영상 정지
    // let getIframe = document.querySelectorAll('.video-popup .iframe');
    // getIframe[index].removeAttribute('src');
    // // 팝업 닫기위해 클래스명 변경
    // document.querySelector('.video-popup').classList.remove('active');
    // $('body').removeAttr('class');
  };

  // 팝업열기
  const videoPopupOpen = function (e) {
    // 동영상 가져오기
    requestVideo(youtubeUrl);
    // 팝업 열기위해 클래스명 변경
    document.querySelector('.video-popup').classList.add('active');
    window.history.pushState({}, '', '');
    document.body.classList.add('scroll-stop');
  };

  useEffect(() => {
    videoPopupOpen();
    // 동영상 갯수만큼 li생성하기 위한 변수
    cloneUl = document.querySelector('#video-ul').innerHTML;

    let btnVideoPopupOpen = document.querySelectorAll('.video-popup-open');
    [].forEach.call(btnVideoPopupOpen, function (btn, index) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        videoPopupOpen();
      });
    });

    // 뒤로가기 버튼 클릭
    window.onpopstate = function (e) {
      if (document.querySelector('.video-popup.active').length > 0) {
        document.querySelector('.video-popup').classList.remove('active');
        document.querySelector('body').classList.remove('scroll-stop');
      }
    };
  }, []);

  return (
    <div className='video-popup'>
      <div className='video-popup-main'>
        <div className='video'>
          <ul id='video-ul'>
            <li className='video-li'>
              <p className='title' />
              <iframe className='iframe' title='abc' />
            </li>
          </ul>
        </div>
        <div className='play-btn'>
          <button className='prev' onClick={videoSlidePrevClick}>
            Previous slide
          </button>
          <button className='next' onClick={videoSlideNextClick}>
            Next slide
          </button>
        </div>
        <button className='play-close' onClick={videoPopupClose}>
          close
        </button>
      </div>
    </div>
  );
}

export default Video;
